/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import checkAnimationExcel from '../../../assets/check-animation-excel.json';
import checkAnimationPowerPoint from '../../../assets/check-animation-powerpoint.json';
import checkAnimationWord from '../../../assets/check-animation-word.json';

declare const Office: any;

export const getCheckAnimationForHost = (hostType: number): any => {
    switch (hostType) {
        case Office.HostType.Word:
            return checkAnimationWord;
        case Office.HostType.Excel:
            return checkAnimationExcel;
        case Office.HostType.PowerPoint:
            return checkAnimationPowerPoint;
        default:
            return checkAnimationWord;
    }
};

export const getCheckAnimationForApp = (): any => {
    const host = Office?.context?.host;
    return getCheckAnimationForHost(host);
};
